<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h4">
        {{ $t('DRIVERS_PAGE_TITLE') }}
        <v-spacer></v-spacer>
        <v-menu
            offset-y>
            <template v-slot:activator="{on}">
                <v-btn
                    icon
                    v-on="on"
                    class="mx-1">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list dense > 
                <v-list-item
                    link
                    v-if="authorizations.drivers.create"
                    @click="openDriverDialog({editMode: false})"
                    >
                    <v-list-item-avatar>
                        <v-icon>mdi-plus-circle</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title>
                        {{ $t('new_driver') }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                    v-if="authorizations.drivers.update && selected.drivers.length == 1"
                    @click="openDriverDialog({editMode: true, id: selected.drivers[0].id})"
                    :disabled="!selected.drivers[0].meta.editable"
                    >
                        <v-list-item-avatar>
                            <v-icon :disabled="!selected.drivers[0].meta.editable">mdi-pencil</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                        <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                        v-if="authorizations.drivers.delete && selected.drivers.length == 1"
                        link
                        @click="openDeleteDecisionDialog(selected.drivers[0].id)"
                        :disabled="!selected.drivers[0].meta.deletable"
                        >
                        <v-list-item-avatar>
                            <v-icon :disabled="!selected.drivers[0].meta.deletable">mdi-delete</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t('ACTIONS_MENU_DELETE') }}</v-list-item-title>
                        </v-list-item-content>
                </v-list-item>
            </v-list>
         </v-menu>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
              <v-btn block color="primary" v-if="authorizations.drivers.create"
                    @click="openDriverDialog({editMode: false})">
              <v-icon left>mdi-database-plus</v-icon>
              {{ $t("new_driver") }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
              <v-btn block depressed v-if="authorizations.drivers.update && selected.drivers.length == 1"
                    @click="openDriverDialog({editMode: true, id: selected.drivers[0].id})"
                    :disabled="!selected.drivers[0].meta.editable">
              <v-icon left>mdi-database-edit</v-icon>
              {{ $t("ACTIONS_MENU_EDIT") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field shaped filled hide-details="auto" dense :label="$t('DRIVERS_PAGE_SEARCH')" v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
            <v-data-table 
                dense
                disable-sort
                :loading="driversLoading"
                single-select
                show-select
                v-model="selected.drivers"
                :items="drivers"
                :server-items-length="total"
                :headers="driversHeaders" 
                :search="search"
                :options.sync="options"
                :page.sync="page"
                >
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <DriverDialog ref="driverDialog" />
    <DecisionDialog @submit="submitDecisionDialog" ref="decisionDialog" />
    <AlertDialog ref="alertDialog" />
  </div>
</template>

<script>
import DriverDialog from "../components/DriverDialog";
import DecisionDialog from "../components/DecisionDialog";
import AlertDialog from "../components/AlertDialog";
import { mapState, mapActions } from "vuex";
export default {
  name: "Drivers",

  components: {
    DriverDialog,
    DecisionDialog,
    AlertDialog
  },

  data() {
    return {
      search: null,
      page: 1,
      selected: {
          drivers: []
      },
      driversHeaders: [
        { text: this.$t("DRIVER_NAME"), value: "name" },
        { text: this.$t("DRIVER_CONTACT"), value: "phone" }
      ],
      loading: {
        data: false
      },
      options: {}
    };
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.fetchDrivers({...this.options, search: this.search});
      }
    },
    search() {
      this.page = 1;
      this.fetchDrivers({...this.options, search: this.search})
    }
  },

  computed: {
    ...mapState("driver", ["drivers", "total", "driversLoading"]),
    ...mapState("authentication", ["loggedInUser", "authorizations"])
  },

  methods: {
    ...mapActions("driver", ["fetchDrivers", "removeDriver"]),
    openDriverDialog(params) {
      this.$refs.driverDialog.open(params);
    },
    openDeleteDecisionDialog(id) {
      this.$refs.decisionDialog.open({
        title: this.$t("DELETE_CONFIRM_TITLE"),
        content: this.$t("DELETE_CONFIRM_CONTENT"),
        action: "DELETE",
        id: id
      });
    },
    submitDecisionDialog(params) {
      if (params.action == "DELETE") {
        this.removeDriver(params.id)
          .then(response => {
            this.fetchDrivers();
            this.$refs.alertDialog.open(
              this.$t("SUCCESS_TITLE"),
              response.message
            );
          })
          .catch(error => {
            this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
          });
      }
    }
  },
  async created() {
    
  }
};
</script>